module.exports = __webpack_public_path__ + "static/tinapastore_resume-2bca0b9976843c4e177cac62f3ed52a3.pdf";